import _ from "lodash";
import moment from "moment-timezone";

import OECDs from "constants/OECDs.json";
import { EVENT_TYPES_OPTIONS } from "constants/config";
import districts from "constants/districts";

import { getStorage } from "hooks/useStorage";

import { EForms, ERoles, ESteps } from "types/enums";

// const phoneRegex = /^(\+7|7|8)?[\s\-]?\(?[0-9][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/;

const Schemas = {
    login: (yup: any, data?: any) =>
        yup.object().shape({
            email: yup.string().email(`Это поле должно быть почтой`).required(`Это поле обязательно`),
            password: yup.string().min(8, `Пароль должен быть не менее 8 символов`).required(`Это поле обязательно`),
        }),
    signup: {
        [ERoles.University]: (yup: any, data?: any) =>
            yup.object().shape({
                name: yup.string().required(`Это поле обязательно`),
                phone: yup.string().required(`Это поле обязательно`),
                email: yup.string().email(`Это поле должно быть почтой`).required(`Это поле обязательно`),
                password: yup.string().min(8, `Пароль должен быть не менее 8 символов`).required(`Это поле обязательно`),
            }),
        [ERoles.Student]: (yup: any, data?: any) =>
            yup.object().shape({
                name: yup.string().required(`Это поле обязательно`),
                // committe: yup.string().required(`Это поле обязательно`),
                phone: yup.string().required(`Это поле обязательно`),
                email: yup.string().email(`Это поле должно быть почтой`).required(`Это поле обязательно`),
                password: yup.string().min(8, `Пароль должен быть не менее 8 символов`).required(`Это поле обязательно`),
                studentRoleType: yup.string().required(`Это поле обязательно`),
            }),
    },
    uniProfileInfo: (yup: any, data?: any) =>
        yup.object().shape({
            photo: yup.string().required(`Это поле обязательно`),
            name: yup.string().required(`Это поле обязательно`),
            shortName: yup.string().required(`Это поле обязательно`),
            founderName: yup.string(),
            site: yup.string().url(`Это поле должно быть ссылкой`).required(`Это поле обязательно`),
            committee: yup.string().required(`Это поле обязательно`),
            region: yup.string(),
            district: yup.string().oneOf(_.map(districts, `id`))
        }),

    studentProfileInfo: (yup: any, data?: any) =>
        yup.object().shape({
            //     photo: yup.string().required(`Это поле обязательно`),
            //     name: yup.string().required(`Это поле обязательно`),
            // shortName: yup.string().required(`Это поле обязательно`),
            // founderName: yup.string(),
            // site: yup.string().url(`Это поле должно быть ссылкой`).required(`Это поле обязательно`),
            // committee: yup.string().required(`Это поле обязательно`),
            // region: yup.string().required(`Это поле обязательно`),
            // district: yup.string().oneOf(_.map(districts, `id`)).required(`Это поле обязательно`),
        }),

    dormitory: {
        [ESteps.MainInfo]: (yup: any, data?: any) =>
            yup.object().shape({
                [ESteps.MainInfo]: yup.object().shape({
                    hideMyInfo: yup.string(),
                    name: yup.string().required(`Это поле обязательно`),
                    city: yup.string().required(`Это поле обязательно`),
                    street: yup.string().required(`Это поле обязательно`),
                    houseNumber: yup.string().required(`Это поле обязательно`),
                    coordinates: yup.object().shape({
                        lat: yup.number().typeError(`Это поле должно быть числом`).required(`Это поле обязательно`),
                        lng: yup.number().typeError(`Это поле должно быть числом`).required(`Это поле обязательно`),
                    }),
                    mealPlan: yup.string().required(`Это поле обязательно`),
                    minDays: yup.number().required(`Это поле обязательно`),
                    maxDays: yup.number().required(`Это поле обязательно`),
                    photos: yup.array().of(yup.string().url()).min(1, `Должна быть хотя бы одна фотография`).required(`Это поле обязательно`),
                    district: yup.string().oneOf(_.map(districts, `id`)),
                }),
            }),
        [ESteps.Rooms]: (yup: any, data?: any) =>
            yup.object().shape({
                [ESteps.Rooms]: yup.object().shape({}),
            }),
        [ESteps.Services]: (yup: any, data?: any) =>
            yup.object().shape({
                [ESteps.Services]: yup.array().of(yup.object().shape(Schemas[EForms.editService])),
            }),
        [ESteps.Rules]: (yup: any, data?: any) =>
            yup.object().shape({
                [ESteps.Rules]: yup.object().shape({
                    requiredUniDocuments: yup.string().required(`Это поле обязательно`),
                    requiredStudentsDocuments: yup.string().required(`Это поле обязательно`),
                    committee: yup.object().shape({
                        name: yup.string().required(`Это поле обязательно`),
                        phone: yup.string().required(`Это поле обязательно`),
                        email: yup.string().email(`Это поле должно быть почтой`).required(`Это поле обязательно`),
                    }),
                }),
            }),
        [ESteps.Documents]: (yup: any, data?: any) =>
            yup.object().shape({
                [ESteps.Documents]: yup.array().of(yup.string().url()).min(1, `Должен быть хотя бы один документ`).required(`Это поле обязательно`),
            }),
    },
    [EForms.editService]: (yup: any, data?: any) =>
        yup.object().shape({
            name: yup.string().required(`Это поле обязательно`),
            description: yup.string().required(`Это поле обязательно`),
            price: yup.number().typeError(`Это поле должно быть числом`).required(`Это поле обязательно`),
            isFree: yup.boolean().required(`Это поле обязательно`),
        }),
    [EForms.editRoom]: (yup: any, data?: any) =>
        yup.object().shape({
            type: yup.string().required(`Это поле обязательно`),
            amount: yup.number().typeError(`Это поле должно быть числом`).required(`Это поле обязательно`),
            price: yup.number().typeError(`Это поле должно быть числом`).required(`Это поле обязательно`),
            isFree: yup.boolean().required(`Это поле обязательно`),
            isAlwaysAvailable: yup.boolean(),
            description: yup.string().required(`Это поле обязательно`),
            photos: yup.array().of(yup.string().url()).min(1, `Должна быть хотя бы одна фотография`).required(`Это поле обязательно`),
            // video: yup.string().required(`Это поле обязательно`),
        }),
    [EForms.editBooking]: (yup: any, data?: any) =>
        yup.object().shape({
            dates: yup
                .object()
                .shape({
                    from: yup.number(),
                    to: yup.number(),
                })
                .test(
                    "is-dates-valid",
                    (d) => `Дата отъезда должна быть позже даты заезда`,
                    (value) => value?.from <= value?.to,
                )
                .test(
                    "is-dates-required",
                    (d) => `Это поле обязательно`,
                    (value) => !!value?.from && !!value?.to,
                ),
            roomId: yup.string().required(`Это поле обязательно`),
            quantity: yup.number().typeError(`Это поле должно быть числом`).required(`Это поле обязательно`),
            comment: yup.string().required(`Это поле обязательно`),
            author: yup.object().shape({
                name: yup.string().required(`Это поле обязательно`),
                contacts: yup.object().shape({
                    committee: yup.string().test(
                        "is-commettee-required",
                        (d) => `Это поле обязательно`,
                        (value) =>
                            (!_.isEmpty(value) && _.get(data, `author.role`) === ERoles.University) || _.get(data, `author.role`) === ERoles.Student,
                    ),
                    phone: yup.string().required(`Это поле обязательно`),
                    email: yup.string().email(`Это поле должно быть почтой`).required(`Это поле обязательно`),
                }),
            }),
        }),
    [EForms.editEvent]: (yup: any, data?: any) =>
        yup.object().shape({
            type: yup.string().oneOf(_.map(EVENT_TYPES_OPTIONS, `value`)).required(`Это поле обязательно`),
            isAlwaysAvailable: yup.boolean(),
            // WoS: yup
            //     .string()
            //     .oneOf(_.map(_.uniqBy(OECDs, "WoS"), "WoS"))
            //     .required(`Это поле обязательно`),
            name: yup.string().required(`Это поле обязательно`),
            // dates: yup
            //     .object()
            //     .shape({
            //         from: yup.number(),
            //         to: yup.number(),
            //     })
            //     .test(
            //         "is-dates-valid",
            //         (d) => `Дата отъезда должна быть позже даты заезда`,
            //         (value) => value?.from <= value?.to,
            //     )
            //     .test(
            //         "is-dates-required",
            //         (d) => `Это поле обязательно`,
            //         (value) => !!value?.from && !!value?.to,
            //     ),
            price: yup.number().typeError(`Это поле должно быть числом`).required(`Это поле обязательно`),
            description: yup.string().required(`Это поле обязательно`),
            photos: yup.array().of(yup.string().url()).min(1, `Должна быть хотя бы одна фотография`).required(`Это поле обязательно`),
        }),
    [EForms.editEventBooking]: (yup: any, data?: any) =>
        yup.object().shape({
            quantity: yup.number().typeError(`Это поле должно быть числом`).required(`Это поле обязательно`),
            fullName: yup.string().required(`Это поле обязательно`),
            phone: yup.string().required(`Это поле обязательно`),
            email: yup.string().email(`Это поле должно быть почтой`).required(`Это поле обязательно`),
            participants: yup.array().of(
                yup.object().shape({
                    fullName: yup.string().required(`Это поле обязательно`),
                    phone: yup.string(),
                    email: yup.string().email(`Это поле должно быть почтой`),
                }),
            ),
        }),
    [EForms.newsArticle]: (yup: any, data?: any) =>
        yup.object().shape({
            title: yup.string().required(`Это поле обязательно`),
            content: yup.string().required(`Это поле обязательно`),
            cover: yup.string().url().required(`Это поле обязательно`),
        }),
    [EForms.createFeedback]: (yup: any, data?: any) =>
        yup.object().shape({
            rating: yup.number().typeError(`Это поле должно быть числом`).required(`Это поле обязательно`),
            topic: yup.string().required(`Это поле обязательно`),
            text: yup.string().required(`Это поле обязательно`),
            photos: yup.array().of(yup.string().url()),
        }),
    [EForms.editLab]: (yup: any, data?: any) =>
        yup.object().shape({
            // All fields are optional for science infrastructure objects
        }),
};

export default Schemas;
